module.exports = __webpack_public_path__ + "img/arrow-clockwise.0445b47a.svg";